// extracted by mini-css-extract-plugin
export default {"container":"UXdCQq","closeButton":"b_0NPx","textArea":"KxwADD"};